import { Component, ErrorInfo, ReactNode } from 'react'
import { ErrorMessage } from 'components/index'
import * as Sentry from '@sentry/react'
import { Button, theme } from '@plurall/elo-beta'

type ErrorBoundaryProps = {
  children: ReactNode
}

type ErrorBoundaryState = {
  error: Error | null
  errorInfo: ErrorInfo | null
  hasError: boolean
  eventId: string
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  static getDerivedStateFromError() {
    return { hasError: true }
  }

  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { error: null, errorInfo: null, hasError: false, eventId: '' }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ error, errorInfo })

    Sentry.withScope(scope => {
      scope.setExtras({
        ...errorInfo,
      })
      const eventId = Sentry.captureException(error)
      this.setState({ eventId })
    })
  }

  render() {
    if (this.state.errorInfo) {
      return (
        <div>
          <ErrorMessage
            src={`${process.env.REACT_APP_ASSETS_URL}/images/what.svg`}
            title='Ops! Ocorreu um erro. Caso o erro persista, entre em contato com o suporte.'
          />
          <details style={{ whiteSpace: 'pre-wrap' }}>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo.componentStack}
          </details>

          {this.state.eventId && (
            <div style={{ textAlign: 'center' }}>
              <Button
                onClick={() => Sentry.showReportDialog({ eventId: this.state.eventId || '' })}
              >
                Reportar Problema
              </Button>
            </div>
          )}
        </div>
      )
    }
    if (this.state.hasError) {
      return (
        <>
          <ErrorMessage
            src={`${process.env.REACT_APP_ASSETS_URL}/images/what.svg`}
            title='Ops! Ocorreu um erro. Caso o erro persista, entre em contato com o suporte.'
          />

          {this.state.eventId && (
            <div style={{ textAlign: 'center', margin: theme?.elo?.spacings?.xSmall }}>
              <Button
                onClick={() => Sentry.showReportDialog({ eventId: this.state.eventId || '' })}
              >
                Reportar Problema
              </Button>
            </div>
          )}
        </>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
